import { isEmpty } from "lodash"
import React, { useMemo } from 'react'
import { useMobileRecordContext } from "../../../contexts/mobileRecordContext"
import { separateChildRecords } from "../../../utilities/mobileRecordHelper"
import GroupedChildRecords from "./groupedChildRecords"

const ChildRecords = ({ map }) => {
  const { descendantRecords } = useMobileRecordContext()

  const childRecordsDict = useMemo(() => {
    return isEmpty(descendantRecords) ? {} : map.reduce((acc, uuid) => acc[uuid], descendantRecords)
  }, [descendantRecords, map])

  const groupedRecords = useMemo(() => {
    return !isEmpty(childRecordsDict) ? separateChildRecords(childRecordsDict) : {}
  }, [separateChildRecords, childRecordsDict])

  return (
    <div className='flex flex-col w-full'>
      {!isEmpty(groupedRecords) && Object.entries(groupedRecords).map(([recordType, records]) => (
        <div key={recordType} className='flex flex-col'>
          <GroupedChildRecords map={map} recordType={recordType} records={records} />
        </div>
      ))}
    </div>
  )
}

export default ChildRecords
